import { css } from '@emotion/core';

export const flex = css`
  display: flex;
`;

export const flexMinWidthZero = css`
  ${flex}
  min-width: 0;
`;

export const flexCenter = css`
  ${flex}
  align-items: center;
  justify-content: center;
`;

export const flexAlignCenter = css`
  ${flex}
  align-items: center;
`;

export const flexJustifyCenter = css`
  ${flex}
  justify-content: center;
`;

export const flexColumn = css`
  ${flex}
  flex-direction: column;
`;
export const flexColumnAlignCenter = css`
  ${flexColumn}
  align-items: center;
`;

export const flexRow = css`
  ${flex}
  flex-direction: row;
`;

export const flexRowAlignCenter = css`
  ${flexRow}
  align-items: center;
`;

export const flexAlignCenterJustifyStart = css`
  ${flexAlignCenter}
  justify-content: flex-start;
`;
